<script>
    import { fly } from 'svelte/transition'
    import { menu, showIntegration, integration, showMenu } from 'store'
    import { menuItemClick } from 'methods'

    $menu.items = $menu.items.length ? $menu.items : []

    let itemLink = (item) => {
        if (item.type == 'link') {
            return item.url.indexOf('://') === -1 ? 'http://' + item.url : item.url
        } else if (item.type == 'email') {
            return 'mailto:' + item.email
        }

        return '#';
    }
</script>

<style lang="scss">aside {
  box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 35px 0px;
  padding: 10px 0px;
  width: 285px;
  background: #fff;
  position: absolute;
  bottom: 85px;
  right: 0;
  border-radius: 5px;
  margin: 0;
  list-style: none;
}
aside > a {
  float: left;
  width: 100%;
  margin: 0;
  padding: 9px 16px;
  cursor: pointer;
}
aside > a:hover {
  background: #f1f1f1;
}
aside > a i {
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  border-radius: 50px;
  float: left;
  margin-right: 14px;
}
aside > a i :global(svg) {
  width: 22px;
  fill: currentColor;
}
aside > a div {
  width: calc(100% - 60px);
  float: left;
}
aside > a div h4 {
  float: left;
  margin: 0px;
  padding: 0px;
  font-size: 14px;
  font-weight: 400;
  margin-top: 1px;
  margin-bottom: 3px;
  color: #333;
  width: 100%;
}
aside > a div span {
  font-size: 13px;
  float: left;
  color: #999999;
  font-weight: normal;
  width: 100%;
}
/*# sourceMappingURL=src/components/Menu.svelte.map */</style>

<aside transition:fly={{ x: 40 }}>
    {#each $menu.items as item}
        <a href={itemLink(item)} target="_blank" on:click={(e) => {
            menuItemClick(item, e)
        }}>
            <i style="background: {item.color};">
                {@html item.icon}
            </i>

            <div>
                <h4>
                    {item.title}
                </h4>

                <span>
                    {item.subtitle}
                </span>
            </div>
        </a>
    {/each}
</aside>